export function globalSite() {

    $('.menu__icon').on('click', function () {
        $('body').toggleClass('scroll_disabled');
        $(this).closest('.header').toggleClass('menu_state_open');
    });

    $('#toTop').on('click', function() {
        $('body,html').animate({scrollTop:0},800);
    });

    function doScrollTop(){
        var check_buy_btn = $('body').find('.hide-foot').length;

        if($(this).scrollTop() != 0 && check_buy_btn == 0) {
            $('#toTop').fadeIn();
        } else {
            $('#toTop').fadeOut();
        }
    }

    function doAnimations(){
        if(window.pageYOffset > 100){
            $('.header').addClass('menu-scroll');
            $('.mob-open-filters').addClass('scroll-filter');
        } else {
            $('.header').removeClass('menu-scroll');
            $('.mob-open-filters').removeClass('scroll-filter');
        }
    }

    function actions() {
        $(document).ready(function () {
            $('#preloader').delay(100).fadeOut("slow");
        });
        $(window).on('scroll', doAnimations);
        $(window).on('scroll', doScrollTop);
    }

    actions();
}


// WEBPACK FOOTER //
// ./assets/js/pages/global_site.js